import {
  GLOBAL_EVENTS,
  PUBLIC_MESSAGE_EVENTS,
  ROLE_GROUPS,
  SOCKET_ROOMS
} from '@moal/api'
import { useContext, useEffect, useState } from 'react'
import { SocketContext } from '../context/socketContext'
import {
  getQuestions,
  unmarkAllQuestions,
  unmarkAsQuestion
} from '../utils/APIs/publicMessages'

export const useQuestions = ({ user }) => {
  const { socket } = useContext(SocketContext)
  const [questions, setQuestions] = useState([])

  useEffect(() => {
    if (socket && user && ROLE_GROUPS.STAFF.includes(user.role.role)) {
      socket.emit(GLOBAL_EVENTS.JOIN_ROOM, {
        user: user,
        room: SOCKET_ROOMS.LIVESTREAM.QUESTIONS
      })

      socket.on(PUBLIC_MESSAGE_EVENTS.MARK_AS_QUESTION, handleMarkAsQuestion)
      socket.on(
        PUBLIC_MESSAGE_EVENTS.UNMARK_AS_QUESTION,
        handleUnmarkAsQuestion
      )
      socket.on(
        PUBLIC_MESSAGE_EVENTS.UNMARK_ALL_AS_QUESTIONS,
        handleUnmarkAllAsQuestions
      )
      socket.on(PUBLIC_MESSAGE_EVENTS.SORT_QUESTION, handleSortQuestion)
      socket.on(PUBLIC_MESSAGE_EVENTS.PUT, handleEditPublicMessage)
      socket.on(PUBLIC_MESSAGE_EVENTS.DELETE, handleDeletePublicMessage)
      getAllQuestions()
    }

    return () => {
      if (socket) {
        socket.emit(GLOBAL_EVENTS.LEAVE_ROOM, SOCKET_ROOMS.LIVESTREAM.QUESTIONS)
        socket.off(PUBLIC_MESSAGE_EVENTS.MARK_AS_QUESTION, handleMarkAsQuestion)
        socket.off(
          PUBLIC_MESSAGE_EVENTS.UNMARK_AS_QUESTION,
          handleUnmarkAsQuestion
        )
        socket.off(
          PUBLIC_MESSAGE_EVENTS.UNMARK_ALL_AS_QUESTIONS,
          handleUnmarkAllAsQuestions
        )
        socket.off(PUBLIC_MESSAGE_EVENTS.SORT_QUESTION, handleSortQuestion)
        socket.off(PUBLIC_MESSAGE_EVENTS.PUT, handleEditPublicMessage)
        socket.off(PUBLIC_MESSAGE_EVENTS.DELETE, handleDeletePublicMessage)
      }
    }
  }, [socket, user])

  const getAllQuestions = async () => {
    try {
      const response = await getQuestions()
      setQuestions(response.data)
    } catch (error) {
      console.log(error)
    }
  }

  const removeAllQuestions = async () => {
    try {
      await unmarkAllQuestions()
    } catch (error) {
      console.log(error)
    }
  }
  const removeQuestion = async (question) => {
    try {
      await unmarkAsQuestion(question._id)
    } catch (error) {
      console.log(error)
    }
  }

  const handleMarkAsQuestion = (data) => {
    setQuestions((prevQuestions) => [...prevQuestions, data])
  }
  const handleUnmarkAsQuestion = (data) => {
    setQuestions((prevQuestions) => [
      ...prevQuestions.filter((q) => q._id !== data._id)
    ])
  }
  const handleUnmarkAllAsQuestions = () => {
    setQuestions([])
  }
  const handleSortQuestion = (data) => {
    setQuestions((prevQuestions) =>
      prevQuestions
        .map((q) => (q._id === data._id ? data : q))
        .sort((a, b) => (a.questionRank > b.questionRank ? 1 : -1))
    )
  }

  const handleEditPublicMessage = (data) => {
    setQuestions((prevQuestions) =>
      prevQuestions.map((q) => (q._id === data._id ? data : q))
    )
  }
  const handleDeletePublicMessage = (data) => {
    setQuestions((prevQuestions) => [
      ...prevQuestions.filter((q) => q._id !== data._id)
    ])
  }

  return {
    questions,
    setQuestions,
    getAllQuestions,
    removeAllQuestions,
    removeQuestion
  }
}
